import styled from "styled-components"

export const Content = styled.div`
  display: grid;
  justify-items: center;
  row-gap: 16px;
`

export const Buttons = styled.div`
  column-gap: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
`

export const Body = styled.div``
